import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5C728A",
      d: "M18.93 5.264A16.5 16.5 0 0 0 14.86 4a.06.06 0 0 0-.066.031c-.175.312-.37.72-.507 1.042a15.2 15.2 0 0 0-4.572 0 11 11 0 0 0-.514-1.042.06.06 0 0 0-.066-.03 16.5 16.5 0 0 0-4.07 1.262.06.06 0 0 0-.027.022C2.445 9.16 1.734 12.938 2.083 16.67a.07.07 0 0 0 .026.048 16.6 16.6 0 0 0 4.994 2.524.07.07 0 0 0 .07-.023c.385-.525.728-1.079 1.021-1.661a.064.064 0 0 0-.034-.089 11 11 0 0 1-1.56-.743.064.064 0 0 1-.006-.107q.157-.118.31-.243a.06.06 0 0 1 .064-.008c3.273 1.494 6.816 1.494 10.051 0a.062.062 0 0 1 .065.008q.151.125.311.243a.064.064 0 0 1-.005.106q-.748.438-1.56.743a.064.064 0 0 0-.035.09c.3.581.643 1.135 1.02 1.66a.06.06 0 0 0 .07.024 16.5 16.5 0 0 0 5.002-2.525.06.06 0 0 0 .027-.045c.417-4.314-.698-8.062-2.957-11.383a.05.05 0 0 0-.026-.025M8.685 14.397c-.986 0-1.798-.905-1.798-2.016s.797-2.016 1.798-2.016c1.008 0 1.813.913 1.797 2.017 0 1.11-.797 2.015-1.797 2.015m6.645 0c-.986 0-1.797-.905-1.797-2.016s.796-2.016 1.797-2.016c1.008 0 1.813.913 1.798 2.017 0 1.11-.789 2.015-1.798 2.015"
    }, null, -1)
  ]))]))
}
export default { render: render }